import { makeStyles } from '@material-ui/core';

import { TerminationPreviewFieldProps } from './TerminationPreviewField.interfaces';

export const useStyles = (props: TerminationPreviewFieldProps) =>
  makeStyles(() => ({
    input: {
      width: props.width ?? 250,
      display: 'flex',
      flexDirection: 'column',
    },
    inputRow: {
      minHeight: 26,
      paddingTop: 10,
      fontSize: 13,
      lineHeight: 1,
      textAlign: 'left',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    inputLabel: {
      width: '100%',
      paddingTop: 5,
      fontSize: 11,
    },
  }));
